<template>
<div class="status-bar sticky-strip">
        <div class="content">
                <div class="container">
                        <span class="status-bar-user">
                                <span class="status-bar-greetings">
                                        <span class="icon move-in hidden-xs"></span>
                                        <a href="/trading" class="highlight">{{$t('general.quick-demo')}}</a>
                                        <span class="icon user-small-red"></span>
                                        <a v-if="!$cookie.get('userID')" class="highlight" href="/login">{{$t('general.log-in')}}{{$cookie.get('userID')}}</a>
                                        <a v-else id="username" class="highlight" href="/account">{{$cookie.get('username')}}</a>
                                        <span v-if="$cookie.get('userID')" class="icon user-small-logout ic_display_name" @click="changeDisplayName()" style="margin-left: -20px;background-image:url(https://bi-winning.org/assets/img/ic_hide_name.png);"></span>
                                        <a v-if="$cookie.get('userID')" href="https://bpw.bi-winning.org/index/sign-out?redirectUrl=https://www.bi-winning.org/">
                                                <span class="icon user-small-logout"></span>
                                                <a class="highlight">{{$t('general.logout')}}</a>
                                        </a>
                                        <!--
            <a v-if="!$cookie.get('userID')" href="/register" class="btn btn-red btn-sm">
              <span class="hidden-xs">{{$t('general.claim-cash-back')}}</span>
              <span class="hidden-sm hidden-md hidden-lg visible-xs">{{$t('general.claim-cash-back')}}</span>
            </a>-->
                                </span>
                                <LocaleChanger />
                        </span>
                </div>
        </div>
</div>
</template>

<script>
import LocaleChanger from './LocaleChanger';
export default {
        components: {
                LocaleChanger,
        },
        mounted: function () {
                this.$nextTick(function () {
                        this.setName();
                })
        },
        methods: {
                setName() {
                        var pairs = document.cookie.split(";");
                        var cokie = {};
                        for (var i = 0; i < pairs.length; i++) {
                                var pair = pairs[i].split("=");
                                cokie[(pair[0] + '').trim()] = pair.slice(1).join('=');
                        }
                        if (cokie && cokie.username) {
                                if (document.getElementById("username")) {
                                        document.getElementById("username").innerHTML = localStorage.getItem("name") == "1" ? "*******" : decodeURI(cokie.username)
                                }
                                if (document.getElementById("usernameSp")) {
                                        document.getElementById("usernameSp").innerHTML = localStorage.getItem("name") == "1" ? "*******" : decodeURI(cokie.username)
                                }

                                if (document.getElementById("usernameSp1")) {
                                        document.getElementById("usernameSp1").innerHTML = localStorage.getItem("name") == "1" ? "*******" : decodeURI(cokie.username)
                                }
                        }
                        const elements = document.getElementsByClassName("ic_display_name");
                        if (elements && elements.length > 0) {
                                const url = localStorage.getItem("name") == "1" ? "https://bi-winning.org/assets/img/ic_show_name2.png" : "https://bi-winning.org/assets/img/ic_hide_name.png"
                                elements[0].style.backgroundImage = `url('${url}')`;
                        }
                },
                changeDisplayName() {
                        if (localStorage.getItem("name") != "1") {
                                localStorage.setItem("name", "1")
                        } else {
                                localStorage.setItem("name", "")
                        }
                        this.setName()
                }

        }
}
</script>
